import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import LeadMagnetSection from "@/components/LeadMagnetSection";
import StatsSection from "@/components/StatsSection";
import PropertyGrid from "@/components/PropertyGrid";
import ServicesSection from "@/components/ServicesSection";
import AboutSection from "@/components/AboutSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FooterSection from "@/components/FooterSection";
import MobileContactBar from "@/components/MobileContactBar";

const Index = () => {
  return (
    <div className="min-h-screen bg-background pt-[3.75rem]">
      <TopBar />
      <Navbar />
      <HeroSection />
      <LeadMagnetSection />
      <StatsSection />
      <PropertyGrid />
      <ServicesSection />
      <AboutSection />
      <TestimonialsSection />
      <FooterSection />
      <MobileContactBar />
    </div>
  );
};

export default Index;
